// extracted by mini-css-extract-plugin
module.exports = {"frontend-vacancies":"_0fd55ca845--frontend-vacancies--zy0aG","content":"_0fd55ca845--content--OwIAF"};